interface MimeTypeMap {
  [key: string]: string;
}

export const mimeToText: MimeTypeMap = {
  // Common text types
  'text/plain': 'Text File',
  'text/html': 'HTML Document',
  'text/css': 'CSS File',
  'text/csv': 'CSV Spreadsheet',
  'application/json': 'JSON Document',
  'text/markdown': 'Markdown',

  // Common image types
  'image/jpeg': 'JPEG Image',
  'image/png': 'PNG Image',
  'image/gif': 'GIF Image',
  'image/svg+xml': 'SVG Image',
  'image/tiff': 'TIFF Image',

  // Common application and office types
  'application/pdf': 'PDF Document',
  'application/zip': 'ZIP Archive',
  'application/msword': 'MS Word Document',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
    'MS Word Document',
  'application/vnd.ms-excel': 'MS Excel Spreadsheet',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
    'MS Excel Spreadsheet',
  'application/rtf': 'Rich Text Format',
  'application/vnd.ms-powerpoint': 'MS PowerPoint Presentation',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation':
    'MS PowerPoint Presentation',
  'text/calendar': 'iCalendar Format',

  // Audio and video
  'audio/mpeg': 'MP3 Audio',
  'video/mpeg': 'MPEG Video',
  'video/mp4': 'MP4 Video',
  'audio/wav': 'Waveform Audio',
  'video/x-msvideo': 'AVI Video',
  'audio/aac': 'AAC Audio',

  // Fallback for unknown types
  'application/octet-stream': 'Binary File',
  default: 'Unknown',
};
